import React, { useState } from 'react';

const FeedbackForm = () => {
  const [isExpanded, setIsExpanded] = useState(true);

  return (
    <div className="glass-card rounded-2xl p-6 mb-8">
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className="w-full flex items-center justify-between text-white font-semibold mb-4 focus:outline-none focus:ring-2 focus:ring-white/50 rounded-lg p-2 hover:bg-white/10 transition-all duration-300"
        aria-expanded={isExpanded}
        aria-controls="newsletter-content"
      >
        <span className="flex items-center space-x-2">
          <svg
            className="w-5 h-5"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            aria-hidden="true"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
            />
          </svg>
          <span>Subscribe to TheBoomer AI Newsletter</span>
        </span>
        <svg
          className={`w-5 h-5 transition-transform duration-300 ${
            isExpanded ? 'rotate-180' : ''
          }`}
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          aria-hidden="true"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M19 9l-7 7-7-7"
          />
        </svg>
      </button>

      <div
        id="newsletter-content"
        className={`transition-all duration-300 overflow-hidden ${
          isExpanded ? 'max-h-[1000px] opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        <div className="space-y-4">
          

          {/* Substack Embed */}
          <div className="flex justify-center">
            <div className="rounded-lg overflow-hidden shadow-lg w-full max-w-md">
              <iframe
                src="https://theboomerai.substack.com/embed"
                height="320"
                style={{
                  border: '1px solid #EEE',
                  background: 'white',
                  width: '100%',
                }}
                frameBorder="0"
                scrolling="no"
                title="TheBoomer AI Newsletter Subscription"
              />
            </div>
          </div>

          <div className="text-center">
            <p className="text-white/60 text-xs">
              Join thousands of AI enthusiasts and professionals who trust
              TheBoomer for the latest AI insights.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeedbackForm;
